const fetchContactForm = async (action, data) => {
  const response = await fetch(action, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  });

  if (!response.ok) {
    throw new Error(`An error occured: ${response.status}`);
  }

  const result = await response.text();
  return result;
};

export default fetchContactForm;
